import { BmarkContainerBlotterId } from "./models/bmark-container-blotter-id.enum";

export class BfxBlotterFilterBarItem {
  constructor(
    public filterName: string = null,
    public filterId: string = "-1",
    public favorited: boolean = false,
    public selected: boolean = false,
    public separator: boolean = false,
  ) {}
}

export const SELECT_SEPARATOR_ITEM: BfxBlotterFilterBarItem = new BfxBlotterFilterBarItem(
  "",
  "-1",
  false,
  false,
  true,
);

export const BLOTTER_FILTER_TEMPERATURE_NODE_NAME = "BFX-BLOTTER-FILTER-TEMPERATURE";

export type BfxBlotterFilterBarData = {
  items: BfxBlotterFilterBarItem[];
  selectedItem: BfxBlotterFilterBarItem;
  blotterId: BmarkContainerBlotterId | string;
};
